export default function (state = {}, action) {
    switch (action.type) {
        case "QUERY_INFO":
            return action.payload;
            break;
        default:
            return state;
    }
}
